<template>
  <div class="card flex justify-end">
    <ul class="flex list-none m-0 p-0 gap-2 items-center">
      <li>
        <button type="button" @click="onThemeToggler">
          <i :class="` pi ${iconClass}`" />
        </button>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { useMapStore } from '@/shared/stores/mapStore'
import { onMounted, ref } from 'vue'
import { useThemeStore } from '@/shared/stores/themeStore'

const iconClass = ref('pi-moon')
let themeClass = localStorage.getItem('themeClass')
const mapStore = useMapStore()
const themeStore = useThemeStore()

onMounted(() => {
  const root = document.getElementsByTagName('html')[0]
  root.classList.remove('p-dark')
  iconClass.value = themeClass === 'p-dark' ? 'pi-moon' : 'pi-sun'
  root.classList.add(!themeClass ? 'no' : themeClass)
  themeStore.setTheme(themeClass ?? 'light')
})

function onThemeToggler() {
  const root = document.getElementsByTagName('html')[0]
  root.classList.toggle('p-dark')
  iconClass.value = iconClass.value === 'pi-moon' ? 'pi-sun' : 'pi-moon'
  localStorage.setItem('themeClass', iconClass.value === 'pi-moon' ? 'p-dark' : '')

  mapStore.changeCurrentTheme()
  themeStore.setTheme(iconClass.value === 'pi-moon' ? 'p-dark' : 'light')
}
</script>
